import React from 'react';

import Details from './components/view/Details';
import Header from './components/view/Header';
import SimilarApps from './components/view/SimilarApps';

const View = (props) => {
  const { app, similarApps } = props;

  return (
    <>
      <Header app={app} />
      <Details app={app} />
      <SimilarApps apps={similarApps} appTitle={app.title} />
    </>
  );
};

export default View;
